export default "__VITE_ASSET__d3d3eb48__"